import { render, staticRenderFns } from "./EditLup.vue?vue&type=template&id=6fa8a28e&"
import script from "./EditLup.vue?vue&type=script&lang=js&"
export * from "./EditLup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports